export const SPACE_TOKENS = [
  'default',
  '5xs',
  '4xs',
  '3xs',
  '2xs',
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl',
  '3xl',
  '4xl',
  '5xl',
  '6xl',
] as const;

export type SpaceToken = (typeof SPACE_TOKENS)[number];

export const getSpaceValue = (token: SpaceToken): string => {
  return token === 'default'
    ? 'var(--alto-grid-gutter-default)'
    : `var(--alto-sem-space-${token})`;
};
